/*
  Upsell del carrito (snippets/cart-upsell.liquid):
  - Agrega la sugerencia y le pide al tema que vuelva a armar el carrito con su evento 'cart:build'.
  - Copia el mensaje de envío gratis junto al total cada vez que el carrito se vuelve a armar.
*/
(function () {
  if (window.omCartUpsellReady) {
    return;
  }
  window.omCartUpsellReady = true;

  function showError(btn, message) {
    var box = btn.closest('.om-upsell__hero, .om-upsell__mini');
    if (!box) {
      return;
    }

    var el = box.parentNode.querySelector('.om-upsell__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'om-upsell__error';
      el.setAttribute('role', 'alert');
      box.insertAdjacentElement('afterend', el);
    }
    el.textContent = message;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-om-upsell-add]');
    if (!btn || btn.disabled) {
      return;
    }

    evt.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    // Va como URLSearchParams (ni string ni FormData) para que el script del bundle de la
    // página de producto, que reescribe la cantidad de cada /cart/add, no la pise.
    var body = new URLSearchParams();
    body.append('id', btn.dataset.variantId);
    body.append('quantity', '1');

    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (response) {
        // Si Shopify responde con HTML (ej. 429) no hay JSON que leer
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) {
            throw data;
          }
          return data;
        });
      })
      .then(function () {
        // Confirmación inmediata: no depende de que el carrito termine de recargarse
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = btn.dataset.addedLabel || 'Agregado';
        btn.setAttribute('aria-label', 'Agregado al carrito');

        // El tema vuelve a armar el carrito y este botón se reemplaza por el markup nuevo.
        // Si a los 4 s sigue acá, la recarga falló: se reintenta una vez.
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () {
          if (document.contains(btn)) {
            document.dispatchEvent(new CustomEvent('cart:build'));
          }
        }, 4000);
      })
      .catch(function (error) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        // description es el mensaje de Shopify para el cliente (ej. sin stock); lo demás es técnico
        showError(btn, (error && error.description) || 'No se pudo agregar. Probá de nuevo.');
      });
  });

  // Barra de envío gratis: el snippet la deja oculta dentro del carrito y acá se copia junto al total.
  // El carrito se vuelve a armar en cada cambio, así que la barra arranca desde donde estaba y el camión avanza.
  function syncShipping() {
    document.querySelectorAll('[data-om-upsell-shipping]').forEach(function (slot) {
      var form = slot.closest('form');
      var source = form && form.querySelector('[data-om-upsell-shipping-source]');
      var previous = slot.dataset.percent;
      slot.hidden = !source;
      slot.innerHTML = source ? source.innerHTML : '';
      slot.classList.toggle('is-reached', !!source && source.dataset.reached === 'true');
      if (!source) {
        delete slot.dataset.percent;
        return;
      }
      slot.dataset.percent = source.dataset.percent;
      var fill = slot.querySelector('[data-om-ship-fill]');
      if (fill && previous != null && previous !== source.dataset.percent) {
        fill.style.width = previous + '%';
        fill.getBoundingClientRect(); // fuerza el layout para que la transición salga del ancho anterior
        fill.style.width = source.dataset.percent + '%';
      }
    });
  }

  function init() {
    syncShipping();
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    document.querySelectorAll('[data-products]').forEach(function (products) {
      new MutationObserver(syncShipping).observe(products, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
